import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';
import { isPhone } from '/@/utils';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@autobind
export default class Card extends Component {
    static propTypes = {
        icon: PropTypes.string,
        name: PropTypes.string,
        color: PropTypes.oneOf([
            'orange',
            'blue',
            'green',
            'green-light',
            'red',
            'gray',
            'white',
            'expertobayer',
            'fieldview',
        ]),
        size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
        direction: PropTypes.oneOf(['column', 'row']),
        handleClick: PropTypes.func,
        bolder: PropTypes.bool,
        offline: PropTypes.bool,
        maxWidth: PropTypes.bool,
        iconElement: PropTypes.any,
        center: PropTypes.bool,
        border: PropTypes.bool,
        shadow: PropTypes.bool,
        smaller: PropTypes.bool,
    };

    static defaultProps = {
        size: 'sm',
        offline: false,
        border: true,
        shadow: true,
    };

    render() {
        const {
            icon,
            name,
            color,
            size,
            direction,
            handleClick,
            bolder,
            offline,
            maxWidth,
            center,
            smaller,
            border,
            shadow,
        } = this.props;

        const classNameColor = classNames(styles[`color-${color}`]);
        const className = classNames(
            styles.name,
            bolder && styles.bolder,
            smaller && styles.smaller,
            offline && styles.nameOffline
        );
        const classNameRoot = classNames(
            styles.root,
            styles[`root-${color}`],
            styles[`root-${direction}`],
            offline && styles.backgroundOffline,
            maxWidth && styles.maxWidth,
            center && styles.center,
            border && styles.border,
            shadow && styles.shadow,
            this.props.className
        );
        return (
            <Fragment>
                <div className={classNameRoot} onClick={handleClick}>
                    <div className={classNameColor}>
                        {!this.props.iconElement ? (
                            <Icon type={icon} size={size} className={classNameColor} padding={false} />
                        ) : (
                            this.props.iconElement
                        )}
                    </div>
                    <div className={styles.containerName}>
                        <Title className={className}>{name}</Title>
                        {offline &&
                            (isPhone() ? (
                                <i className={classNames('material-icons', styles.iconOffline)}>wifi_off</i>
                            ) : (
                                <div className={styles.containerOffline}>
                                    <Title className={styles.textOffline}>{_('No disponible offline')}</Title>
                                    <i className={classNames('material-icons', styles.iconOffline)}>wifi_off</i>
                                </div>
                            ))}
                    </div>
                </div>
            </Fragment>
        );
    }
}
